export const readonlyKeys = [
  "createdat",
  "createdAt",
  "updatedat",
  "updatedAt",
];

export const nonConfigurableFields = ["id", "createdAt"];
